// extracted by mini-css-extract-plugin
export default {"root":"Skeleton_root__2Do24","line":"Skeleton_line__26Ge8","loading":"Skeleton_loading__5KRly","rounded":"Skeleton_rounded__G0-Q8"};